var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
        'app-button',
        { 'is-loading': _vm.loading, 'is-disabled': _vm.disabled },
        _vm.className
    ],attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":_vm.onClick}},[_c('span',{staticClass:"inner"},[_c('span',{staticClass:"text"},[_vm._t("default")],2),_vm._v(" "),(_vm.icon)?_c('span',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.$icon(_vm.icon))}}):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('span',{staticClass:"loader",domProps:{"innerHTML":_vm._s(_vm.$icon('loader'))}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }